<template>
  <UiTooltip v-if="resolvedTooltip" :position="tooltipPosition">
    <template #trigger>
      <div class="comment-btn-wrap">
        <button type="button" class="comment-btn" :data-btn-activity-id="activityId" @click="$emit('click', $event)">
          <i class="icon icon-comment"></i>
        </button>
        <div v-if="badgeCount > 0" class="notification-wrapper">
          <span class="notification-count">{{ badgeLabel }}</span>
        </div>
      </div>
    </template>
    <p>{{ resolvedTooltip }}</p>
  </UiTooltip>
  <div v-else class="comment-btn-wrap">
    <button type="button" class="comment-btn" :data-btn-activity-id="activityId" @click="$emit('click', $event)">
      <i class="icon icon-comment"></i>
    </button>
    <div v-if="badgeCount > 0" class="notification-wrapper">
      <span class="notification-count">{{ badgeLabel }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const { t } = useI18n();

const props = defineProps({
  count: {
    type: [Number, String],
    default: 0,
  },
  activityId: {
    type: String,
    default: '',
  },
  tooltip: {
    type: String,
    default: undefined,
  },
  tooltipPosition: {
    type: String,
    default: 'bottom-right',
  },
});

defineEmits(['click']);

const resolvedTooltip = computed(() => props.tooltip ?? t('common.activityCard.writeFeedback'));
const badgeCount = computed(() => Number(props.count) || 0);
const badgeLabel = computed(() => (badgeCount.value > 99 ? '99+' : String(badgeCount.value)));
</script>
